/**
 * @generated SignedSource<<9df70edaddea023fb75b680d1bd93e19>>
 * @relayHash c43476813693f586ef9f76e460fc0950
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 395efed32643d87420942d85e2ce2f4be85783ffdcf9511e200d754b49abb420

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type IssueRealtimeUpdates_issueDeletedSubscription$variables = {
  cloudId: string;
  projectIds?: ReadonlyArray<string> | null | undefined;
};
export type IssueRealtimeUpdates_issueDeletedSubscription$data = {
  readonly jira: {
    readonly onIssueDeletedByProjectsNoEnrichment: {
      readonly resource: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type IssueRealtimeUpdates_issueDeletedSubscription = {
  response: IssueRealtimeUpdates_issueDeletedSubscription$data;
  variables: IssueRealtimeUpdates_issueDeletedSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIds"
  }
],
v1 = [
  {
    "concreteType": "JiraSubscription",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "projectIds",
            "variableName": "projectIds"
          }
        ],
        "concreteType": "JiraIssueDeletedStreamHubPayload",
        "kind": "LinkedField",
        "name": "onIssueDeletedByProjectsNoEnrichment",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "resource"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "IssueRealtimeUpdates_issueDeletedSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IssueRealtimeUpdates_issueDeletedSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "395efed32643d87420942d85e2ce2f4be85783ffdcf9511e200d754b49abb420",
    "metadata": {},
    "name": "IssueRealtimeUpdates_issueDeletedSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "fa81f223fcea7547f6cc63c2d4607b6c";

export default node;
